<template>
    <div class="all">
        <img src="../../assets/img/title.png" class="title" />
        <div class="title_text">导师培训证明打印</div>
        <div class="select_box">

            <van-field readonly clickable name="picker" :value="seepartname" label="会议名称" placeholder="点击选择会议"
            @click="showParty = true" :rules="[{ required: true, message: '请选择会议' }]" />
        </div>

        <vs-card v-if="url">
            <template #img>
                <div style="width: 450px">
                    <pdf ref="pdf" @loaded="loadover()" :src="url"> </pdf>
                </div>
            </template>
            <template #text>
                <vs-button block success icon @click="downloadfile">
                    下载
                </vs-button>
            </template>
        </vs-card>





        <a href="javascript:void(0);" id="oDownLoad" style="display:none;">下载a</a>


        <van-overlay :show="iframeloading" style="    padding-top: calc(50vh - 20px);">
            <van-loading color="#1989fa" />
        </van-overlay>

        <van-popup v-model="showParty" position="bottom" :style="{ height: '40%' }" round>
        <van-picker title="会议名称" show-toolbar :columns="options4" @confirm="onConfirm2" @cancel="onCancel2"
            value-key="name" />
        </van-popup>
    </div>
</template>
<script>
import pdf from "vue-pdf";
import { signpdf, getDownload, GroupByHYMC } from "@/api/data/view"; //
export default {
    components: {
        pdf,
    },
    filters:{
        key(text) {
             var temp = document.createElement("div");
            //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
            temp.innerHTML = text;
            //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
            var output = temp.innerText || temp.textContent;
            temp = null;
            return output;
        }
    },
    data() {
        return {
            iframeloading: false,
            iframeshow: false,
            iframe: ``,

            options4: [],
            value1: '',
            value2: '',
            src: "",
            name: "",
            loading: null,
            url: null,
            prindid: null,
            viewid: null,
            selectloading: false,

            viewlist: [{
                id: 1,
                name: 1
            }],
            showParty: false,

            seepartname:'',
            partyname: '',

        }
    },
    methods: {
        onConfirm2(value) {
            console.log(value, 'value');

            this.partyname = value;
            this.seepartname = this.htmlDecode(value);
            this.showParty = false;

            this.signpdffun();
        },
        onCancel2() {
            this.showParty = false;
        },
        async getlist() {
            this.options4 = await GroupByHYMC();
        },
        htmlDecode(text) {
            //1.首先动态创建一个容器标签元素，如DIV
            var temp = document.createElement("div");
            //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
            temp.innerHTML = text;
            //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
            var output = temp.innerText || temp.textContent;
            temp = null;
            return output;
        },
        async valuechange(value) {
            this.value1 = value;

            this.value2 = this.htmlDecode(value);


            // let res = await getViewInfo(this.viewid,null,this.value1);
            // this.name = res.name;

            // this.loading = this.$vs.loading({
            //     type: "corners",
            // });
            this.signpdffun();
        },
        async downloadfile() {
            let path = await getDownload(this.prindid);

            const u = navigator.userAgent;
            console.log(u, "u");
            const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            if (isAndroid) {
                // 安卓终端使用iframe
                window.open(path);
            } else if (isiOS) {
                var odownLoad = document.getElementById('oDownLoad');
                odownLoad.href = path;
                odownLoad.download = "";
                odownLoad.click();

            } else {
                // 1.如果是地址
                window.open(path);
                //2.如果是文件流
            }
        },
        signpdffun() {
            this.iframeloading = true;
            signpdf(this.viewid, null, this.partyname).then(
                (res) => {
                    this.prindid = res;
                    this.url =
                        process.env.VUE_APP_BASE_API + "/AuthorPdf?PrintId=" + this.prindid;

                    //  this.iframe = `https://verify.ink/viewer?url=${this.url}&search=false&sign=false&show-signature-if-present=false&notify-if-not-signed=false&download=true&filename=1.pdf`
                    this.iframeshow = true;
                }
            ).finally(_ => {
                console.log(_);
                this.iframeloading = false;
            })
        },
        loadover() {
            this.loading.close();
        },
    },
    async mounted() {
        await this.getlist();
        if (this.$route.query && this.$route.query.viewid) {
            this.viewid = this.$route.query.viewid;
        } else {
            this.$vs.notification({
                progress: "auto",
                color: "danger",
                position: "top-center",
                title: "错误信息",
                text: "viewid为空",
            });
        }
        // this.url = process.env.VUE_APP_BASE_API + "/createpdf?viewid=" + 18;

        //this.$nextTick(()=>{
        //     const iframe = this.$refs.Iframe;
        //     console.log(iframe,'next');
        //     if (iframe.attachEvent) { // IE
        //         iframe.attachEvent('onload', () => {
        //             this.loading.close();
        //         });
        //       } else { // 非IE
        //         iframe.onload =  () => { this.loading.close(); };
        //       }
        //   })
    },
}
</script>

<style lang="scss" scoped>
::v-deep .vs-card {
    max-width: 375px;
    padding-top: 20px;
}

.title_text {
    font-size: 1.2rem;
    font-family: 'fangsong';
    margin: 2rem 0;
}

.title {
    width: 55%;
    max-width: 300px;
}

.all {
    background: #f5f5f5;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    padding: 2rem 0.2rem;
    box-sizing: border-box;
    overflow-x: hidden;
}

.aaaa {
    margin-top: 5vh;
}

iframe {
    border: 0px;
    height: 420px;
    width: 100%;
}

::v-deep .vs-card {
    margin: auto;
}

::v-deep .vs-card__img {
    max-height: 500px;
    padding-top: 1rem;
}

@media screen and (min-height: 667px) {
    .all {
        padding: 1rem 0.2rem;
    }

    .aaaa {
        margin-top: 1vh;
    }
}

@media screen and (min-height: 700px) {
    .all {
        padding: 3rem 0.2rem;
    }

    .aaaa {
        margin-top: 2vh;
    }
}

@media screen and (min-height: 800px) {
    .all {
        padding: 3rem 0.2rem;
    }

    .aaaa {
        margin-top: 2rem;
    }
}


@media screen and (min-height: 896px) {
    .all {
        padding: 3rem 0.2rem;
    }

    .aaaa {
        margin-top: 2rem;
    }
}

.select_box {
    padding: 0 1rem;
}

.vs-select-content {
    max-width: 100%;
}
</style>